import { render, staticRenderFns } from "./ProfileExpert.vue?vue&type=template&id=448a2bf4&scoped=true&"
import script from "./ProfileExpert.vue?vue&type=script&lang=js&"
export * from "./ProfileExpert.vue?vue&type=script&lang=js&"
import style0 from "./ProfileExpert.vue?vue&type=style&index=0&id=448a2bf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a2bf4",
  null
  
)

export default component.exports